(function($) {

	/* Document ready functions */
	$(document).ready(function (){

    $('.filter-btn').on('click', function(){
      var term = $(this).data('term');
      $('.filter-btn').removeClass('active');
      $(this).addClass('active');
      $('.service-item').hide();
      if(term == 'term-all'){
        $('.service-item').show();
      } else {
        $('.' + term).show();
      }
    });


	});

	$(window).resize(function () {


	});

})(jQuery);
